import { Component, Input, OnInit } from '@angular/core';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { MeasurementService } from '../../../../../services/measurement.service';
import { CalculationResult } from '../../../models/calculationModels';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';

@Component({
    selector: 'app-bolt-output',
    templateUrl: './bolt-output.component.html',
    styleUrls: ['./bolt-output.component.scss'],
})
export class BoltOutputComponent implements OnInit {
    @Input()
    set calcOutput(value: CalculationResult) {
        this._calcOutput = value;
        if (value != undefined && value != null) {
            this.loadBoltValues();
        }
    }
    get calcOutput(): CalculationResult {
        return this._calcOutput;
    }
    resBoltLoad: string;
    resBoltStress: string;
    resboltYield: string;
    private _calcOutput: CalculationResult;

    constructor(
        private measSvc: MeasurementService,
        private globalEmmiterService: GlobalEmittersService
    ) {}

    ngOnInit(): void {
        this.globalEmmiterService.unitUpdated.subscribe((resp) => {
            if (resp) {
                this.loadBoltValues();
            }
        });
    }

    loadBoltValues() {
        this.resBoltLoad = this.measSvc.getUserPreferedValue(this.calcOutput?.output?.bolt?.residualBoltLoad, UnitType.DefaultForceUnit);
        this.resBoltStress = this.measSvc.getUserPreferedValue(this.calcOutput?.output?.bolt?.residualBoltStress, UnitType.DefaultStressUnit);
        this.resboltYield = this.measSvc.getFormattedPercentage(this.calcOutput?.output?.bolt?.residualBoltYieldPercentage);
    }
}
